"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteTotalConfig = void 0;
var react_1 = __importDefault(require("react"));
var server_1 = __importDefault(require("react-dom/server"));
var QuoteTotal_1 = __importDefault(require("@CommonFrontend/Public/Widgets/QuoteTotal"));
exports.QuoteTotalConfig = {
    type: "quoteTotal",
    tokenType: {},
    publicRender: function (_a) {
        var attributes = _a.attributes;
        return server_1.default.renderToString(react_1.default.createElement(QuoteTotal_1.default, {
            attributes: attributes,
        }));
    },
    traits: {
        widgetId: {},
    },
};
